﻿export default function typesCount (value, onlyWords = false) {
    const postfixes = ['ов', '', 'а', 'а', 'а', 'ов', 'ов', 'ов', 'ов', 'ов'];
    const lastDigits = value % 100;

    if (lastDigits > 10 && lastDigits < 20) {
        return onlyWords ? 'тип' : `${Math.trunc(value)} тип`;
    }
    else {
        return onlyWords ? `тип${postfixes[value % 10]}` : `${Math.trunc(value)} тип${postfixes[value % 10]}`;
    }
}